import React from 'react';
import PropTypes from 'prop-types';
import PopulationSelect from './PopulationSelect';
import AccessibilitySelect from './AccessibilitySelect';
import LanguagesSelect from './LanguagesSelect';
import ResidencyRequirements from './ResidencyRequirements';
import DistanceFilter from './DistanceFilter';

const AdvancedFilters = (props) => {
  const {
    accessibility,
    google,
    languages,
    map,
    onClearAll,
    onFieldChange,
    onMultiFieldChange,
    population,
    states,
    values,
  } = props;

  return (
    <div className="uu-search-advanced-filters">
      <div className="uu-search-advanced-filters__group">
        <h4>Specialized Support</h4>
        <PopulationSelect
          onFieldChange={onMultiFieldChange}
          population={population}
          values={values}
        />
        <AccessibilitySelect
          accessibility={accessibility}
          onFieldChange={onMultiFieldChange}
          values={values}
        />
        <LanguagesSelect
          languages={languages}
          onFieldChange={onMultiFieldChange}
          values={values}
        />
      </div>
      <div className="uu-search-advanced-filters__group">
        <h4>Residency Requirement</h4>
        <ResidencyRequirements
          onFieldChange={onMultiFieldChange}
          states={states}
          values={values}
        />
      </div>
      <div className="uu-search-advanced-filters__group">
        <h4>Distance</h4>
        <DistanceFilter
          google={google}
          map={map}
          onFieldChange={onFieldChange}
          values={values}
        />
      </div>
      <div className="uu-clear-filters">
        <button
          id="uu-clear-filters__button"
          type="button"
          onClick={onClearAll}
        >
          Clear All
        </button>
      </div>
    </div>
  );
};


AdvancedFilters.propTypes = {
  accessibility: PropTypes.array.isRequired,
  google: PropTypes.object,
  languages: PropTypes.array.isRequired,
  map: PropTypes.object,
  onClearAll: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onMultiFieldChange: PropTypes.func.isRequired,
  population: PropTypes.array.isRequired,
  states: PropTypes.array.isRequired,
  values: PropTypes.object.isRequired,
};

AdvancedFilters.defaultProps = {
  google: {},
  map: {},
};

export default AdvancedFilters;



// WEBPACK FOOTER //
// ./public/js/components/Search/AdvancedFilters.jsx